var map = {
	"./cognizant-logo.png": "8caf",
	"./createjs-logopng.png": "7dc0",
	"./git.png": "14d3",
	"./ipu-logo.png": "517b",
	"./line.svg": "4d20",
	"./loader.gif": "95cd",
	"./mongo.png": "13b9",
	"./nagarro-logo.png": "bc5f",
	"./newpic-placeholder.png": "6985",
	"./newpic.png": "bf4e",
	"./ptu-logo.png": "e0f4",
	"./sql.png": "b96d",
	"./taazaa-logo.png": "d4da"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";